import { AccountMultipleIcon } from './AccountMultipleIcon';

/**
 * author: Google
 * id A8C2EE6C-31B9-4D51-B941-8128FDD77A96
 * name account-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple.svg
 * tags
 * - Account / User 
 */
export const AccountsIcon = AccountMultipleIcon;
export default AccountsIcon